import type { PayoutInputs } from '#shared/rules/payoutRules'
import type { MachineTier, TierProjection } from '@/types/landing/landingTypes'
import { projectPayout } from '#shared/rules/payoutRules'
import { TIER_DEPOSITS, TIER_POLICY_REQUIREMENTS } from '#shared/constants/vaultRules'

/**
 * The landing tier chart: what a visitor would earn joining each depositing tier at its
 * minimum, from the payout rule in `shared/rules/payoutRules.ts`.
 *
 * Depositing above the minimum grows the pot for everyone but not the visitor's share of it,
 * so the minimum is the only deposit projected.
 */

/** Ordered cheapest to richest; the chart renders them in this order. */
export const MACHINE_TIERS = ['bronze', 'silver', 'gold'] as const satisfies readonly MachineTier[]

export function projectTier(tier: MachineTier, inputs: PayoutInputs): TierProjection {
  const { perYear, perPeriod } = projectPayout(inputs, { kind: 'newcomer', tier })

  return {
    tier,
    deposit: TIER_DEPOSITS[tier],
    perYear,
    perPeriod,
    policyTypes: TIER_POLICY_REQUIREMENTS[tier],
  }
}
